export default __webpack_public_path__ + "static/media/chime4.cb31f0ee.mp3";